var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconRecentFollow = function SvgIconRecentFollow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.333 11.664a4.166 4.166 0 0 1 4.167 4.167v1.666a.833.833 0 0 1-1.667 0v-1.666a2.5 2.5 0 0 0-2.5-2.5H6.667a2.5 2.5 0 0 0-2.5 2.5v1.666a.833.833 0 0 1-1.667 0v-1.666a4.167 4.167 0 0 1 4.167-4.167zm4.512-4.1a.833.833 0 0 1 1.248 1.1l-.07.08-2.356 2.357a.833.833 0 0 1-1.1.069l-.079-.07-1.178-1.178a.834.834 0 0 1 1.1-1.248l.078.07.59.59zM10 1.665a4.167 4.167 0 1 1 0 8.333 4.167 4.167 0 0 1 0-8.333m0 1.667a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5",
    clipRule: "evenodd"
  })));
};
export default SvgIconRecentFollow;